import React from "react";
import HomePageContent from '../functional-components/HomePageContent/HomePageContent.jsx';

const HomePage =()=> {
    return (
        <div>
            <HomePageContent />
        </div>
    );
};

export default HomePage;